module.exports = __webpack_public_path__ + "img/refresh.2758de41.svg";